import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-devops-placeholder-card',
  imports: [TranslatePipe],
  templateUrl: './devops-placeholder-card.component.html',
  styleUrl: './devops-placeholder-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsPlaceholderCardComponent {
  titleKey = input.required<string>();
  descriptionKey = input.required<string>();
}
